import script from "./MainApp.vue?vue&type=script&setup=true&lang=js"
export * from "./MainApp.vue?vue&type=script&setup=true&lang=js"

import "./MainApp.vue?vue&type=style&index=0&id=a06da9e8&scoped=true&lang=css"

import exportComponent from "/Users/alberto/sites/newform/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a06da9e8"]])

export default __exports__